import React, {useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import axios from 'axios';
import Spinner from '../common/generic/Spinner';
import { longButtonStyle } from '../common/theme';


function ReportWindowModal (props) {

    const [ htmlReport, setHTMLReport ] = useState('');
    const [ isFetching, setIsFetching ] = useState(false);

    const fetchReport = async () => {
        setIsFetching (true);
        const response = await axios.get('report.html');
        setTimeout(function(){  
            setHTMLReport(response.data);
            setIsFetching (false);
        }, 1000);
      };   
    
    //useEffect( () => { fetchReport(htmlReport); }, [ htmlReport ] );
    
    return (
    <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
            Complete Reading Grade 3 - Mr Jones - Jamie Whitten
        </Modal.Title>
        </Modal.Header>
        <Modal.Body>

        <div style={{paddingTop:'20px'}}>
            <Row>        
                <Col xs={3}><Button style={longButtonStyle} variant="info"> View Skill Report </Button></Col>
                <Col xs={3}><Button style={longButtonStyle} variant="info"> View Activity Report </Button></Col>
                <Col xs={3}><Button style={longButtonStyle} variant="info" onClick={() => fetchReport(htmlReport) }> View Unit Report </Button></Col>
                <Col xs={3}><Button style={longButtonStyle} variant="info"> View Hot-Spot Report </Button></Col>
            </Row> 
            <Row> 
                <Col xs={3}><Button style={longButtonStyle} variant="info"> View Pre-Test Report </Button></Col>
                <Col xs={3}><Button style={longButtonStyle} variant="info"> View Post-Test Report </Button></Col>
            </Row> 
        </div>
        {(isFetching) &&
            <span><Spinner/></span>
        }
        <div dangerouslySetInnerHTML={{__html: htmlReport}}/>
        </Modal.Body>
        <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
    </Modal>
    );

}

export default ReportWindowModal;